import { Timestamp } from "firebase/firestore/lite";
import { DbBusinessPaymentType } from "../business/models";
import { DbServiceBookingStatus } from "../booking/models";
import { DbBusinessReview } from "../business/models";

export enum DbVisitType {
  WalkIn = "walk_in",
  Advance = "advance",
}

export interface WalkInServiceInput {
  business_id: string;
  user_id: string;
  entity_id: string;
  service_id: string;
  service_time: string;
  booking_date: string;
  service_duration: number;
  booking_amount?: number;
  payment_membership_id?: string;
}

export interface WalkInProductInput {
  inventory_id?: string;
  id?: string;
  name?: string;
  amount: number;
  quantity: number;
  total_amount?: number;
}

export interface WalkInFinancialSummary {
  tax_amount: number;
  total_amount: number;
  paid_amount: number;
  membership_discount_total?: number;
}

export interface WalkInPaymentInput {
  type: DbBusinessPaymentType | string;
  amount: number;
  payment_id?: string | null;
  reward_points?: number;
}

export interface WalkInCreateRequest {
  business_id: string;
  user_id: string;
  type: DbVisitType;
  booking_date?: string;
  services: WalkInServiceInput[];
  products: WalkInProductInput[];
  financial_summary: WalkInFinancialSummary;
  payments?: WalkInPaymentInput[];
  additional_note?: string;
}

export interface WalkInUpdateRequest {
  services: WalkInServiceInput[];
  products: WalkInProductInput[];
  financial_summary: WalkInFinancialSummary;
  payments?: WalkInPaymentInput[];
  booking_date?: string;
  additional_note?: string;
}

export interface DbVisitProductItem {
  id: string;
  name: string;
  quantity: number;
  amount: number;
  total_amount: number;
  membership_discount_amount: number;
}

export interface DbVisitServiceItem {
  type: DbVisitType;
  booking_id: string;
}

export interface DbVisitPaymentItem {
  created_at: Timestamp;
  type: DbBusinessPaymentType | string;
  amount: number;
  payment_id?: string;
  business_payee_id?: string;
  reward_points?: number;
}

export interface DbVisitFinancialSummary {
  service_total: number;
  product_total: number;
  subtotal: number;
  tax_amount: number;
  total_amount: number;
  paid_amount: number;
  membership_discount_total?: number;
}

export interface DbVisitInvoiceInfo {
  gst_code?: string | null;
  gst_number?: string | null;
  hsn_code?: string | null;
}

export interface DbVisit {
  id: string;
  business_id: string;
  user_id: string;

  type: DbVisitType;

  products: DbVisitProductItem[];
  services: DbVisitServiceItem[];
  review?: DbBusinessReview;

  financial_summary: DbVisitFinancialSummary;
  invoice_info?: DbVisitInvoiceInfo;

  booking_date?: Timestamp;
  business_member_created_id?: string;
  share_id?: string;
  created_at: Timestamp;

  payments: DbVisitPaymentItem[];

  alert_type?: string | null;
  alert_at?: Timestamp | null;

  additional_note?: string;

  status?: DbServiceBookingStatus;
}
